import React from 'react';

import ProcurementApprovalsItemInfoModal from './ProcurementApprovalsItemInfoModal';
import ProcurementApprovalsTableHeadTile from './ProcurementApprovalsTableHeadTile';
import ProcurementApprovalsTableTile from './ProcurementApprovalsTableTile';

export default function ProcurementApprovalsTable(props) {
    return (
        <div>
            <div className="tw-flex tw-flex-row tw-items-stretch">
                {props.groups.map((group) => {
                    const key = Object.keys(group)[0];
                    const val = Object.values(group)[0];

                    return <ProcurementApprovalsTableHeadTile key={key} text={val} />;
                })}
            </div>
            {props.fetched && (
                <>
                    <div className="tw-flex tw-flex-row tw-items-stretch">
                        {props.groups.map((group) => {
                            const key = Object.keys(group)[0];
                            const datum = props.dataSet[key];

                            return (
                                <div key={`data-${key}`} className="tw-basis-3/12">
                                    {datum?.map((item) => {
                                        return (
                                            <ProcurementApprovalsTableTile
                                                key={item.id}
                                                item={item}
                                                groupName={key}
                                                loading={props.loading}
                                                showProcurementInfoModal={props.showProcurementInfoModal}
                                                closeModal={props.closeModal}
                                            />
                                        );
                                    })}
                                </div>
                            );
                        })}
                    </div>
                </>
            )}

            <ProcurementApprovalsItemInfoModal
                modalRef={props.procurementInfoModalRef}
                modalElement={props.procurementModalElement}
                onClose={props.closeModal}
                procurement={props.procurement}
                listUsersUrl={props.listUsersUrl}
                downloadAttachmentUrl={props.downloadAttachmentUrl}
            />
        </div>
    );
}
